export const setImageModelIdFromSnippet = (e: MouseEvent, setCurrentImageModelId: (id: number) => void) => {
  const target = e.target as HTMLElement;

  if (!target.hasAttribute('data-snippet')) return;
  if (!target.getAttribute('data-snippet').includes('IMAGE_MODEL')) return;

  const snippet = target.getAttribute('data-snippet');
  const idMatch = snippet.match(/\d+/);

  if (!idMatch[0]) return;

  setCurrentImageModelId(parseInt(idMatch[0], 10));
};

export const setIsEquationFromSnippet = (e: MouseEvent, setIsEquation: (b: boolean) => void) => {
  const target = e.target as HTMLElement;

  setIsEquation(target?.getAttribute('data-is-equation') === 'true');
};
